import { ScrollSpeed } from '@usacsmideo/types';

export const SpeedController = (props: ScrollSpeed) => {
  const min = props.min ?? 25;
  const max = props.max ?? 180;

  return (
    <div className="my-2 grid w-full grid-cols-[auto_1fr_auto] items-center gap-4">
      <button
        id="faster"
        onClick={() => {
          props.setSpeed(Math.max(min, props.speed - 6));
        }}
        className="text-left"
        aria-label="Increase scroll speed"
      >
        Faster
      </button>
      <input
        id="speed-slider"
        className="slider"
        type="range"
        min={min}
        max={max}
        value={props.speed}
        onChange={(e) => props.setSpeed(parseInt(e.target.value))}
        disabled={props.scrolling}
        aria-label="Adjust scroll speed"
        aria-valuetext={`Speed: ${props.speed} seconds`}
      />
      <button
        id="slower"
        onClick={() => {
          props.setSpeed(Math.min(max, props.speed + 6));
        }}
        className="text-right"
        aria-label="Decrease scroll speed"
      >
        Slower
      </button>
    </div>
  );
};
